import React, { PureComponent as Component } from 'react'
import {  Redirect } from "react-router-dom";
import {   XInput } from '../../../ui/template/Layout/Layout';
import '../../../style/login.scss';
import {Helmet} from "react-helmet";
import login from "./Api/Login";
import Alerts from "../../../ui/template/Alert/Alerts";
import FormManager from "../../../ui/template/Form/FormManager";
import Field from "../../../ui/template/Form/Field";
import Submit from "../../../ui/template/Form/Submit";
import { MCbrowser } from '../../Context/browserContext';




class Login extends Component{

    constructor(props) {
        super(props);
        this.handleUsernameChange = this.usernameChange.bind(this);
        this.handlePasswordChange = this.passwordChange.bind(this);
        this.handleLoginUp = this.loginUp.bind(this);
        this.values = {username: '',password: ''};
        this.form1=React.createRef();
        this.pageAlerts=React.createRef();
        this.formAlerts=React.createRef(); 
        this.props=props;

    }

    componentDidMount() { 
        let b1=this.context.pageBWindow; 
        let isLogined=this.context.isLoggedIn;
        if (!isLogined) {
            if(b1.isCef) b1.SystemCaptionBar();
        }
        document.body.className ='full-page' ;
        //document.body.style.direction = "ltr";
    }

    render() { 
        let isLogined=this.context.isLoggedIn;
        if(isLogined===true){
            return (
                <Redirect to="/membership/" />
            )
        }
        return (
            <React.Fragment>
                <Helmet>
                    <meta name="viewport" content="width=device-width, initial-scale=1" />
                    <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
                    <meta name="robots" content="noindex" />
                    <title>
                        ورود به سامانه مردمی دولت یاران
                    </title>
                    <style>
                        @import url("/css/color.css");
                        @import url("/css/all.css");
                        @import url("/css/rippleEffect.css");
                        @import url("/css/card.css");
                        @import url("/css/form.css");
                        @import url("/css/customStyle.css");
                        @import url("/css/theme.css");
                    </style>
                 </Helmet>
                <div className="bg-full d-flex align-items-center">
                    <div className="container h-100  d-flex align-items-center  flex-column">
                        <div className="row w-100 position-relative ">
                            <div className="col-12 col-md-5 mr-auto ml-auto text-center">
                                <a itemProp="name" className="home-brand" href="http://mdyaran.ir/">
                                    سامانه مردمی دولت یاران
                                </a>
                            </div>
                            <a   className="home_label" href="http://mdyaran.ir/">
                                صفحه اصلی
                            </a>
                        </div>
                        <div className="card card1  card2 card-1000 m-auto part16"
                             ref={(node) => {
                                 if (node) {
                                     node.style.setProperty("border", "none", "important");
                                 }
                             }} >
                            <div className="card-body  ">
                                <div className="container-fluid p-0">
                                    <div className="row  no-gutters   position-relative ltr">
                                        <div className="d-none  d-md-block col col-12  col-sm-12  col-md-7 col-lg-8 part16-1   h-100 ">
                                            <div className="card-pic    ">
                                                <div className="img"  style={{backgroundImage: `url(/images/bg-2.jpg)`}} />
                                                <span/>
                                            </div>
                                        </div>
                                        <div  className="col col-12  col-sm-12  col-md-5 col-lg-4  part16-2   part17-2  text-right   ">
                                            <div  className=" ml-sm-5 d-flex   align-items-center justify-content-center pl-sm-0 pr-sm-4 ">
                                                <div className="   part16-3 part17-3 text-center       ">
                                                    <FormManager ref={this.form1} submit={this.handleLoginUp} className="rtl text-left   dform">
                                                        <h5 className="h2 color-text-dark">
                                                            ورود
                                                        </h5>
                                                        <Field    >
                                                            <div className="form-group ">
                                                                <label htmlFor="input3">
                                                                    نام کاربری
                                                                </label>
                                                                <XInput  type="text" className="form-control text-right" onChange={this.handleUsernameChange}  />
                                                            </div>
                                                        </Field>
                                                        <Field    >
                                                            <div className="form-group ">
                                                                <label htmlFor="input4">
                                                                    گذر واژه
                                                                </label>
                                                                <XInput type="password" className="form-control text-right" onChange={this.handlePasswordChange}
                                                                        placeholder="گذر واژه خود را وارد نمائید" />
                                                                <a className="nav-link d-inline-block color-text-secondary cursor-pointer pr-1 color-text-muted font-8 "
                                                                href="http://mdyaran.ir/membership/reset">
                                                                    گذر واژه خود را فراموش کرده اید؟
                                                                </a>
                                                            </div>
                                                        </Field>

                                                        <Alerts layout="relative" ref={this.formAlerts}/>
                                                        <div className="form-group mt-3">
                                                            <Submit className="p-side-0 btn   btn-block  ">
                                                                    ورود
                                                            </Submit>
                                                            <p className="text-center font-8">
                                                                ایا قبلا ثبت نام نکرده اید ؟
                                                                <a className="nav-link d-inline-block color-text-secondary cursor-pointer pr-1 "
                                                                   href="http://mdyaran.ir/membership/register">
                                                                    ثبت نام
                                                                </a>
                                                            </p>
                                                        </div>
                                                    </FormManager>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Alerts ref={this.pageAlerts} />
            </React.Fragment>
        )
    }

    usernameChange(e) {
        this.values.username= e.target.value;
        return true;
    }

    passwordChange(e) {
        this.values.password= e.target.value;
        return true;
    }

    async loginUp() {
        let l=await login(this.values.username,this.values.password,this.pageAlerts,this.formAlerts);
        if(l===true){
            this.props.logged();
        }
    }

} 
Login.contextType = MCbrowser;
export default Login;